(function () {
  function getHref(url) {
    return /^https?:\/\//i.test(url) ? url : 'https://' + url;
  }

  function splitTrailingPunctuation(url) {
    var trailing = '';

    while (/[.,;:!?)]$/.test(url)) {
      trailing = url.slice(-1) + trailing;
      url = url.slice(0, -1);
    }

    return {
      url: url,
      trailing: trailing
    };
  }

  function linkifyTextNode(textNode) {
    var text = textNode.nodeValue;
    var urlPattern = /(?:https?:\/\/|www\.)[^\s<]+|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:com|net|org|co|io|us|biz|info|store|shop|dental|health)(?:\/[^\s<]*)?/gi;
    var match;
    var lastIndex = 0;
    var fragment = document.createDocumentFragment();

    while ((match = urlPattern.exec(text)) !== null) {
      var rawUrl = match[0];
      var clean = splitTrailingPunctuation(rawUrl);

      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }

      var link = document.createElement('a');
      link.href = getHref(clean.url);
      link.textContent = clean.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      fragment.appendChild(link);

      if (clean.trailing) {
        fragment.appendChild(document.createTextNode(clean.trailing));
      }

      lastIndex = match.index + rawUrl.length;
    }

    if (lastIndex === 0) {
      return;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function linkifyElement(element) {
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.parentElement && node.parentElement.closest('a')) {
          return NodeFilter.FILTER_REJECT;
        }

        return /(?:https?:\/\/|www\.)|(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:com|net|org|co|io|us|biz|info|store|shop|dental|health)(?:\/[^\s<]*)?/i.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(linkifyTextNode);
  }

  function initPromoAutolinks() {
    document
      .querySelectorAll('.promo-description, .promo-qualifications')
      .forEach(linkifyElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoAutolinks);
  } else {
    initPromoAutolinks();
  }
})();
